export function canAddCbtGuests(
  isCbtEnabled: boolean,
  allowGuests?: boolean,
  soloTraveler = false
): boolean {
  return isCbtEnabled && !!allowGuests && !soloTraveler;
}
